import { r as registerInstance, h, F as Fragment } from './index-5faac9d7.js';
import { Y as CATEGORY } from './currency-49e0d692.js';
import './product-card-78a466f2.js';
import { s as store } from './pes-router-store-498d2799.js';
import './store-a2f488b2.js';
import './index-39f51a91.js';
import { a as getFilteredBreadcrumbs } from './utils-1b416b6b.js';
import { a as addHostToHmcUrls } from './utils-f0ef036b.js';
import './pick-8e119733.js';
import './_basePickBy-19dc1369.js';
import './_arrayLikeKeys-26c55d84.js';
import './isEmpty-ea893565.js';
import './_nodeUtil-549406aa.js';
import './_commonjsHelpers-7db8bc26.js';
import './isSymbol-8fefec05.js';
import './_Stack-cf94d4e7.js';
import './toString-568546f3.js';
import './_isIndex-3036d479.js';
import './keysIn-b6895676.js';
import './hasIn-833a7ad2.js';
import './_flatRest-cc9038d0.js';
import './_baseFlatten-eecfdcde.js';
import './index-43880fda.js';
import './pes-product-link-74e48119.js';
import './utils-cdf9de4e.js';
import './analytics-b3108572.js';
import './helpers-cd261aee.js';
import './tslib.es6-613ce1cd.js';
import './navigation-83d2f79a.js';
import './toNumber-d92ee08f.js';
import './index-67820103.js';
import './utils-2fbd0743.js';
import './_baseFor-a28737de.js';
import './_copyObject-3791899f.js';
import './constants-7d3b1dc0.js';
import './number-fcf5283d.js';
import './analytics-74fe4f64.js';
import './utils-6c8f178b.js';
import './index-54dd34b7.js';
import './lodash-7f024380.js';

const PesAppCategory = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.host = undefined;
    this.showBreadcrumbs = undefined;
    this.categoryAllData = null;
    this.categoryId = undefined;
    this.recentlyViewedProducts = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.storageName = '';
    this.currentPageStorageKey = '';
  }
  componentWillRender() {
    store.set('enableAppRouting', true);
  }
  componentWillLoad() {
    this.storageName = `${this.host}${this.countryCode}/${this.languageCode}/`;
    this.currentPageStorageKey = `${CATEGORY}/${this.categoryId}`;
  }
  get customBreadcrumbs() {
    if (!this.showBreadcrumbs) {
      return null;
    }
    return getFilteredBreadcrumbs(this.categoryAllData.breadcrumbs.breadcrumbs);
  }
  get hmcBanner() {
    var _a, _b;
    if (!((_b = (_a = this.categoryAllData) === null || _a === void 0 ? void 0 : _a.mainInfo) === null || _b === void 0 ? void 0 : _b.hmcBanner)) {
      return null;
    }
    const { hmcBanner } = this.categoryAllData.mainInfo;
    addHostToHmcUrls(this.host, hmcBanner);
    return hmcBanner;
  }
  render() {
    const { breadcrumbs: { hideOnMobile }, descriptionInfo: { name, description, readLessLabel, readMoreLabel, badge = null }, mainInfo: { commonFiltersFilterBy, commonFiltersProductFiltersLabel, commonFiltersShowRanges, commonFiltersClearAllLabel, commonFiltersOfferTypeLabel, rangePartofLabel, rangeProductsViewDetailsLabel, productRelationsViewProdLabel, viewOnLabel, readMoreLabel: readMoreLabelMainInfo, readLessLabel: readLessLabelMainInfo, newFilters, subCategories, }, } = this.categoryAllData;
    return (h(Fragment, null, this.showBreadcrumbs && (h("pes-breadcrumbs", { breadcrumbs: this.customBreadcrumbs, hideOnMobile: hideOnMobile, hostWithLocale: this.storageName })), h("pes-category-heading", { name: name, description: description, readLessLabel: readLessLabel, readMoreLabel: readMoreLabel, badge: badge }), h("pes-subcategories", { name: name, sourceId: this.categoryId, commonFiltersFilterBy: commonFiltersFilterBy, commonFiltersProductFiltersLabel: commonFiltersProductFiltersLabel, commonFiltersShowRanges: commonFiltersShowRanges, commonFiltersClearAllLabel: commonFiltersClearAllLabel, commonFiltersOfferTypeLabel: commonFiltersOfferTypeLabel, rangePartofLabel: rangePartofLabel, rangeProductsViewDetailsLabel: rangeProductsViewDetailsLabel, productRelationsViewProdLabel: productRelationsViewProdLabel, viewOnLabel: viewOnLabel, readMoreLabel: readMoreLabelMainInfo, readLessLabel: readLessLabelMainInfo, newFilters: newFilters, subCategories: subCategories, hmcBanner: this.hmcBanner, avoidAccents: true, isPBS: true, categoryId: this.categoryId, currentPageStorageKey: this.currentPageStorageKey, storageName: this.storageName }), h("pes-products-carousel", Object.assign({}, this.recentlyViewedProducts, { isBackgroundGrey: true, class: "pes-app-category__section", hostWithLocale: this.storageName, pageId: this.categoryId, pageType: CATEGORY }))));
  }
};

export { PesAppCategory as pes_app_category };
